import { Text } from '@vinted/web-ui'

import { FormattedRelativeTime } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  time: string
}

const MessageTime = ({ time }: Props) => {
  const timeValue = new Date(time).getTime()

  return (
    <div className="u-flexbox u-justify-content-center u-ui-margin-vertical-small">
      <Text as="h4" text={<FormattedRelativeTime value={timeValue} />} type={Text.Type.Caption} />
    </div>
  )
}

export default MessageTime
